<section data-component="flex-seo" class="row">

  <div *ngIf="primaryMode && !newCMSContent" class="primaryMode  w-100">
    <div class="row justify-content-center align-items-center">
        <div class="col-md-12 text-center">
            <h2 class="headline" [innerHTML]="pageData?.copy$$signon_flex_seo_headline?.TEXT"></h2>
            <div class="subhead" [innerHTML]="pageData?.copy$$signon_flex_seo_subhead?.TEXT"></div>
            <div class="card-image" [attr.data-brandId]="brandId" alt="Card Art"></div>
        </div>
    </div>
  </div>

  <div *ngIf="!primaryMode" class="defaultMode w-100">
      <div class="row justify-content-center align-items-center">
          <div class="col-md-12 text-center">
              <h2 class="headline" [innerHTML]="pageData?.copy$$signon_flex_seo_headline?.TEXT"></h2>
              <div class="subhead" [innerHTML]="pageData?.copy$$signon_flex_seo_subhead?.TEXT"></div>
          </div>
      </div>
  </div>


  <div *ngIf="primaryMode && newCMSContent" class="primaryMode w-100" >
    <div class="row justify-content-center align-items-center">
      <div class="col-md-12 text-center">
        <h2 class="headline" [innerHTML]="pageData?.copy$$signon_primary_banner_headline?.TEXT"></h2>
        <div class="subhead" [innerHTML]="pageData?.copy$$signon_primary_banner_subhead?.TEXT"></div>
        <div class="card-image" [attr.data-brandId]="brandId" alt="Card Art"></div>
      </div>
    </div>
  </div>

</section>
